import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

import { showWidget, setWidgetEnabled, setViewedJobs } from './actions'
import { DEFAULT_VIEWED_JOBS, DEFAULT_SHOW_WIDGET, DEFAULT_WIDGET_ENABLED } from './defaultState'

export const viewedJobs = handleActions({
  [setViewedJobs]: (_, { payload }) => payload
}, DEFAULT_VIEWED_JOBS)

export const show = handleActions({
  [showWidget]: (_, { payload }) => payload
}, DEFAULT_SHOW_WIDGET)

export const enabled = handleActions({
  [setWidgetEnabled]: (_, { payload }) => payload
}, DEFAULT_WIDGET_ENABLED)

export default combineReducers({ viewedJobs, show, enabled })
